/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MIMChangeAnalysisChartRequestDTO { 
    /**
     * Measured client identifier
     */
    clientId: number;
    /**
     * Brand identifier within the client
     */
    brandId: number;
    /**
     * Conversion event type for the change analysis chart
     */
    conversionType: string;
    /**
     * Current period start date in ISO-8601 format
     */
    dateStart: string;
    /**
     * Current period end date in ISO-8601 format
     */
    dateStop: string;
    /**
     * Comparison period start date in ISO-8601 format
     */
    compareDateStart: string;
    /**
     * Comparison period end date in ISO-8601 format
     */
    compareDateStop: string;
    /**
     * Granularity of the comparison, used to label the periods
     */
    granularity: MIMChangeAnalysisChartRequestDTO.GranularityEnum;
    /**
     * Chart view: \'ChangeInOrders\' for absolute order deltas, \'ChangeInOrdersPerc\' for percent of comparison-period total
     */
    viewBy: MIMChangeAnalysisChartRequestDTO.ViewByEnum;
}
export namespace MIMChangeAnalysisChartRequestDTO {
    export type GranularityEnum = 'Weekly' | 'Monthly' | 'Quarterly' | 'Yearly';
    export const GranularityEnum = {
        Weekly: 'Weekly' as GranularityEnum,
        Monthly: 'Monthly' as GranularityEnum,
        Quarterly: 'Quarterly' as GranularityEnum,
        Yearly: 'Yearly' as GranularityEnum
    };
    export type ViewByEnum = 'ChangeInOrders' | 'ChangeInOrdersPerc';
    export const ViewByEnum = {
        ChangeInOrders: 'ChangeInOrders' as ViewByEnum,
        ChangeInOrdersPerc: 'ChangeInOrdersPerc' as ViewByEnum
    };
}


